import React from 'react'
import { Flex, Typography } from 'components'
import empty_message from 'assets/chat_empty.svg'

export type ChatEmptyProps = {}

export const ChatEmpty: React.FC<ChatEmptyProps> = () => {
  return (
    <Flex fullHeight fullWidth middle="zero" center="zero" directionColumn="zero" gap={1}>
      <img src={empty_message} height="80" alt="empty message" />
      <Flex directionColumn="zero" gap={0.25} middle="zero">
        <Typography color="grey700" fontSize="text_md" fontWeight="semibold">
          Start Chatting
        </Typography>
        <Typography color="grey600" fontSize="text_sm" align="center">
          You can ask Evreka AI about the data you see on the left. <br />
          Have a zero waste day!
        </Typography>
      </Flex>
    </Flex>
  )
}
